import React from 'react'
import { useTranslation } from 'react-i18next'
import { DocumentList } from '../documents'
import type { EntityDocument } from '../documents/DocumentList'

type SaleDocumentationVehicleTabProps = {
  vehicleId: string | null | undefined
  vehicleRegistryDocuments: EntityDocument[]
}

export const SaleDocumentationVehicleTab: React.FC<SaleDocumentationVehicleTabProps> = ({
  vehicleId,
  vehicleRegistryDocuments,
}) => {
  const { t } = useTranslation()

  if (!vehicleId) {
    return (
      <p className="text-sm text-muted-foreground">
        {t('financialSales.saleDocumentation.noVehicle')}
      </p>
    )
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        {t('financialSales.saleDocumentation.vehicleRegistryHint')}
      </p>
      <DocumentList
        documents={vehicleRegistryDocuments}
        readOnly
        title={t('financialSales.saleDocumentation.vehicleListTitle')}
        emptyMessage={t('financialSales.saleDocumentation.vehicleRegistryEmpty')}
      />
    </div>
  )
}
